// 龚郎郎的个人封装工具函数
export default {
  // 防抖函数
  debounce(func, wait) {
    let timeout = null
    return function() {
      const context = this
      const args = arguments
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        func.apply(context, args)
      }, wait)
    }
  }
}

export let deduplicate = (arr, t = '') => {
  const newArr = [arr[0]]
  // 有指定字段
  if (t) {
    for (let i = 1; i < arr.length; i++) {
      let repeat = false
      for (let j = 0; j < newArr.length; j++) {
        if (t && arr[i][t] === newArr[j][t]) {
          repeat = true
          break
        }
      }
      if (!repeat) newArr.push(arr[i])
    }
  } else {
    // 无指定字段
    for (let i = 1; i < arr.length; i++) {
      let repeat = false
      for (let j = 0; j < newArr.length; j++) {
        if (arr[i] === newArr[j]) {
          repeat = true
          break
        }
      }
      if (!repeat) newArr.push(arr[i])
    }
  }
  return newArr
}



// WEBPACK FOOTER //
// ./src/utility_class/my_kit.js